import { render, staticRenderFns } from "./AxProjectInviteSettings.vue?vue&type=template&id=682f9790&scoped=true&"
import script from "./AxProjectInviteSettings.vue?vue&type=script&lang=ts&"
export * from "./AxProjectInviteSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AxProjectInviteSettings.vue?vue&type=style&index=0&id=682f9790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f9790",
  null
  
)

export default component.exports